<script>
import ProductTagChantier from './atoms/ProductTagChantier.vue'
import axios from 'axios'

export default {
  components: { ProductTagChantier },
  data: function() {
    return {
      mainTagList: null
    }
  },
  created: function() {
    this.updateAllTagList()
  },
  methods: {
    getTagNames() {
      return new Promise((resolve, reject) => {
        axios.get('/tag/chantier/list').then(
          response => {
            resolve(response.data)
          },
          response => {
            reject(response)
          }
        )
      })
    },
    updateAllTagList: function() {
      this.getTagNames().then(
        response => {
          this.mainTagList = response
        },
        response =>
          console.log('Error - getTagNames' + JSON.stringify(response))
      )
    },
    clearMainTagList: function() {
      this.mainTagList = null
    }
  }
}
</script>
